import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarRemove4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarRemove4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15V4H9V2H7V4ZM9.74803 8.83579L8.33381 10.25L10.5856 12.5018L8.33579 14.7517L9.75 16.1659L11.9998 13.916L14.2497 16.1659L15.6639 14.7517L13.4141 12.5018L15.6659 10.25L14.2517 8.83579L11.9998 11.0876L9.74803 8.83579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarRemove4;
